"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalJobQuery = void 0;
/**
 * Query for selecting logs analyzed by the historical job.
 */
class HistoricalJobQuery {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return HistoricalJobQuery.attributeTypeMap;
    }
}
exports.HistoricalJobQuery = HistoricalJobQuery;
/**
 * @ignore
 */
HistoricalJobQuery.attributeTypeMap = {
    aggregation: {
        baseName: "aggregation",
        type: "SecurityMonitoringRuleQueryAggregation",
    },
    distinctFields: {
        baseName: "distinctFields",
        type: "Array<string>",
    },
    groupByFields: {
        baseName: "groupByFields",
        type: "Array<string>",
    },
    hasOptionalGroupByFields: {
        baseName: "hasOptionalGroupByFields",
        type: "boolean",
    },
    metrics: {
        baseName: "metrics",
        type: "Array<string>",
    },
    name: {
        baseName: "name",
        type: "string",
    },
    query: {
        baseName: "query",
        type: "string",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=HistoricalJobQuery.js.map